import { useState, useEffect, useMemo, useRef } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { usePost } from './../../../apis/ApiRequests';
import { useNavigate } from 'react-router-dom';
import HeaderMobile from './components/Header';
import MenuIconMobile from './components/MenuIcon';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import GradeIcon from '@mui/icons-material/Grade';
import PreviewIcon from '@mui/icons-material/Preview';
import { addDays, format, parse } from 'date-fns';
import { dateToString } from '../../../utils/Library';
import InfoIcon from '@mui/icons-material/Info';
import AddCircleIcon from '@mui/icons-material/AddCircle'
import {
  Box,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Stack,
  TextField,
  Typography,
  MenuItem,
  ButtonBase,
  ClickAwayListener,
  Chip,
  Switch,
} from "@mui/material";
import TitleBar from '../../../components/uiParts/TitleBar';
import CustomSelect from '../../../components/select/CustomSelect';
import { dogList } from '../../../Store';
import CustomConfirm from '../../../components/confirm/CustomConfirm';
import CustomSnackBar from '../../../components/alert/CustomSnackBar';

const DOCKS = [1, 2, 3, 4, 5];

// 表示パラメータ
const START_HOURS = 3;
const END_HOURS = 16;
const OPERATING_HOURS = END_HOURS - START_HOURS;
const MINUTES_STEP = 15;
const START_MINUTES = START_HOURS * 60;
const END_MINUTES = END_HOURS * 60;
const OPERATING_MINUTES = OPERATING_HOURS * 60;

// 1分あたりの高さ(px) → 15分で 30px
const PX_PER_MIN = 2;
const HEADER_H = 44;
const TIME_COL_W = 70;

//時間外の値
const OUT_TIME = "時間外"

function pad2(n) {
  return String(n).padStart(2, "0");
}
function minutesToHHMM(m) {
  const hh = Math.floor(m / 60);
  const mm = m % 60;
  return `${pad2(hh)}:${pad2(mm)}`;
}
function hhmmToMinutes(hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
}
function nowMinutes() {
  const d = new Date();
  return d.getHours() * 60 + d.getMinutes();
}
//HHMM⇒HH:MM
function formatHHMM(date,hhmm) {
  const referenceDate = parse(`${date}${hhmm}`,"yyyyMMddHHmm",new Date());
  return format(referenceDate,"HH:mm")
}
//HH:MM⇒HHMM
function unformatHHMM(hhmm) {
  return hhmm.replace(":","");
}

const ScheduleMobile = () => {

    const { authInfo } = useAuth();
    const navigate = useNavigate();

    //===============================================
    // initialize
    //===============================================
    //-----------------------------------------------
    // initialize - セッション情報を取得
    //-----------------------------------------------
    const facilityCode = authInfo.facilityCode;
    const facilityName = authInfo.facilityName;
    const userId = authInfo.userId;
    const userName = authInfo.userName;
    const authority = authInfo.authority;
    const traderCode = authInfo.traderCode;
    const trader = authInfo.trader;
    const senmeiCode   =
        authInfo.senmeiCode === null
            ? null
            : !isNaN(Number(authInfo.senmeiCode))
                ? Number(authInfo.senmeiCode)
                : authInfo.senmeiCode;
    const senmei = authInfo.senmei;
    const isCoopUser = authority == 2;

    const scrollRef = useRef(null);

    //-----------------------------------------------
    // initialize - useState
    //-----------------------------------------------

    // スマホは 1～5番ドックを SELECT して、対象列だけ表示する
    const [selectedDock, setSelectedDock] = useState(1);

    // 追加/編集ダイアログ
    const [open, setOpen] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const today = format(addDays(new Date(), 0), 'yyyy-MM-dd');
    const [keepNewId, setKeepNewId] = useState(false);

    // 削除確認
    const [ openConfirm, setOpenConfirm] = useState(false);

    // スナックバー
    const [ openSnackBarTrue,  setOpenSnackBarTrue  ] = useState(false);
    const [ openSnackBarMessageFalse,  setOpenSnackBarMessageFalse  ] = useState(false);
    const [ message, setMessage ]= useState("");
    const [ openSnackBarDisabled,  setOpenSnackBarDisabled  ] = useState(false);
    const [ openRequire,  setOpenRequire  ] = useState(false);

    // フォーム
    const [form, setForm] = useState({
        dock: 1,
		start: 480,
		end: 540,
        outTime: false,
        senmeiCode: senmeiCode,
        biko: "",
        method:[],
    });
    
	// 回数でソートされたスケジュール
    const [sortedSchedule, setSortedSchedule] = useState([])
    
    // 入船回数の最大
    const maxKaisu = useMemo(() => {
        if (!Array.isArray(sortedSchedule) || sortedSchedule.length === 0) {
            return 0;
        }
        return Math.max(...sortedSchedule.map(item => item.kaisu ?? 0));
    }, [sortedSchedule]);

    // 現在時刻ライン表示用
    const nowMin = nowMinutes();
    const nowY = nowMin * PX_PER_MIN;

    // 1日の高さ
	const bodyH = OPERATING_MINUTES * PX_PER_MIN;

    // 時刻選択用 予約枠
    const timeSlot = useMemo(() => {
        const rows = 24;
		const columns = 60 / MINUTES_STEP;
        return Array.from({length: rows * columns}, (_, index) => ({
            minutes: index * MINUTES_STEP,
            status: '○',
            selected: false
        }));
    }, []);
    const [slotState, setSlotState] = useState(timeSlot);

    //ボタン配置用 グルーピング
    const groupedByHour = useMemo(() => {
        if (OPERATING_HOURS <= 0) return [];

        const result = Array.from({ length: 24 }, () => []);
        slotState.forEach(slot => {
            const hour = Math.floor(slot.minutes / 60);
            
            if (hour >= START_HOURS && hour < END_HOURS) {
                result[hour - START_HOURS].push(slot);
            }
        });
        return result.filter(hourRow => hourRow.length > 0);
    }, [slotState]);

    //時刻選択用
    const [selectTimeOpen, setSelectTimeOpen] = useState(false);
    const [startIndex, setStartIndex] = useState(null);
    const [endIndex, setEndIndex] = useState(null);
    const [clickPrevIndex, setClickPrevIndex] = useState(null);

    //時間外メニュー
    const [outTimeOpen, setOutTimeOpen] = useState(false);

    //===============================================
    // API
    //===============================================
    //-----------------------------------------------
    // API - searchDataByCalendar / PortSchedule
    //-----------------------------------------------
    const { response : searchPostResponse, post : searchPostData } = usePost();
    const searchDataByCalendar_func = async () => {
        const postData = {
            'className'    : 'mch.models.table.PortSchedule',
            'methodName'   : 'searchDataByCalendar',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'keyword1'     : dateToString(today),
        }
        await searchPostData(postData);
    }
    //-----------------------------------------------
    // API - getNextId / PortSchedule
    //-----------------------------------------------
    const { response : getNextId_Res, post : getNextIdPost } = usePost();
    const getNextId_func = async () => {
        const postData = {
            'className'    : 'mch.models.table.PortSchedule',
            'methodName'   : 'getNextId',
            'facilityCode' : facilityCode,
        }
        await getNextIdPost(postData);
    }
    //-----------------------------------------------
    // API - setData / PortSchedule
    //-----------------------------------------------
    const { response : setDataResponse, post : setDataPost } = usePost();
    const setData_func = async (registerData) => {
        const postData = {
            'className'     : 'mch.models.table.PortSchedule',
            'methodName'    : 'setData',
            'facilityCode'  : facilityCode,
            'scheduleId'    : registerData.id,
            'userId'        : userId,
            'activeFlag'    : registerData.activeFlag,
            'scheduleDate'  : dateToString(today),
            'senmeiCode'    : registerData.senmeiCode,
            'senmei'        : registerData.shipName,
            'lineNo'        : registerData.dock||selectedDock,
            'startMin'      : registerData.startMin,
            'endMin'        : registerData.endMin,
            'biko'          : registerData.biko,
            'methodCodeList': registerData.methodCodeList,
            'methodList'    : registerData.methodList,
			'kaisu'         : registerData.kaisu
        }
        await setDataPost(postData);
    }
    //-----------------------------------------------
    // API - deleteData / PortSchedule
    //-----------------------------------------------
    const { response : deleteDataResponse, post : deleteDataPost } = usePost();
    const deleteData_func = async (scheduleId) => {
        const postData = {
            'className'     : 'mch.models.table.PortSchedule',
            'methodName'    : 'deleteData',
            'facilityCode'  : facilityCode,
            'scheduleId'    : scheduleId,
            'userId'        : userId,
        }
        await deleteDataPost(postData);
    }
    //-----------------------------------------------
    // API - searchData / table_portschedule
    //-----------------------------------------------
    const { response : searchDataSenmeiCodeAndDate_Res, post:searchDataSenmeiCodeAndDate_post } = usePost();
    const searchDataSenmeiCodeAndDate = async (targetSenmeiCode) => {

        const postData = {
            'className'    : 'mch.models.table.PortSchedule',
            'methodName'   : 'searchDataSenmeiCodeAndDate',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'senmeiCode'   : targetSenmeiCode ?? senmeiCode,
            "scheduleDate" : dateToString(today),
        }
        await searchDataSenmeiCodeAndDate_post(postData);
    };	
    //-----------------------------------------------
    // API - searchData / masta_Ship
    //-----------------------------------------------
    const { response : searchData_Res, post:searchData_Post } = usePost();
    const searchShipData = async () => {
        const postData = {
            'className'    : 'mch.models.masta.Ship',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId,
        }
        await searchData_Post(postData);
    };
    //-----------------------------------------------
    // API - searchData / masta.FishMethod
    //-----------------------------------------------
    const { response : getDataAll_fishMethod_res, post : getDataAll_fishMethod_post } = usePost();
    const getDataAll_fishMethod = async () => {
        const postData = {
            'className'    : 'mch.models.masta.FishMethod',
            'methodName'   : 'searchData',
            'facilityCode' : facilityCode,
            'userId'       : userId
        }
        await getDataAll_fishMethod_post(postData);
    };
    //===============================================
    // useEffect
    //===============================================
    //-----------------------------------------------
    // useEffect - ロード時の設定
    //-----------------------------------------------
    useEffect(() => {
        searchDataByCalendar_func();
        getDataAll_fishMethod();
        searchShipData();
        const el = scrollRef.current;
        if (!el) return;

        // 現在時刻に自動スクロール
        const t = setTimeout(() => {
            const m = nowMinutes();
            const targetY = (m - START_MINUTES) * PX_PER_MIN;

            // ヘッダがスクロール領域内に入ったので、ヘッダ高さ分を少し考慮
            const offset = HEADER_H + 80;
            const maxScroll = el.scrollHeight - el.clientHeight;
            const nextTop = Math.max(0, Math.min(targetY - offset, maxScroll));

            el.scrollTop = nextTop;
        }, 0);

        return () => clearTimeout(t);
    }, []);
    //-----------------------------------------------
    // useEffect - APIレスポンス(setData / table_PortSchedule)
    //-----------------------------------------------
    useEffect(() => {
        if(setDataResponse){
            const fetchData = async () => {
                await searchDataByCalendar_func();
                await searchShipData();
            }
            fetchData();
            if(setDataResponse.statusCode){
                handleClickSnackBarTrue();
                if(form.dock) setSelectedDock(form.dock);
                setOpen(false);
            }else{
                setMessage(setDataResponse?.result)
				handleClickSnackBarMessageFalse();
            }
        }
    }, [setDataResponse]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(deleteData / table_PortSchedule)
    //-----------------------------------------------
    useEffect(() => {
        const fetchData = async () => {
            await searchDataByCalendar_func();
            await searchShipData();
        }
        fetchData();

        if(deleteDataResponse){
            if(deleteDataResponse.statusCode){
                handleClickSnackBarTrue();
            }
        }
		handleCloseConfirm();
    }, [deleteDataResponse]);
    //-----------------------------------------------
    // useEffect - APIレスポンス(searchDataSenmeiCodeAndDate / table.PortSchedule)
    //-----------------------------------------------
    useEffect(()=>{
        if(searchDataSenmeiCodeAndDate_Res){
            const sortSchedule = [...(searchDataSenmeiCodeAndDate_Res?.Data ?? [])].sort(
                    (a, b) => (a.kaisu ?? 0) - (b.kaisu ?? 0)
            )
            setSortedSchedule(sortSchedule)
            setKeepNewId(false);
            if(editingId==="new"){
                setForm(prev =>{
                    const next = {
                        ...prev, 
                        method: [], 
                        biko: "",
                        kaisu: maxKaisu + 1
                    }
                    return next;
                });
                return;
            }
            const selectedSchedule = (sortSchedule ?? []).find((item) => item.scheduleId === editingId);
            if (selectedSchedule) {
                setForm(prev => {
                    const outTime = (selectedSchedule.startMin === OUT_TIME || selectedSchedule.endMin === OUT_TIME)
                    const next = {
                        dock: selectedSchedule.lineNo || prev.dock,
                        start: outTime ? prev.start : selectedSchedule.startMin ? hhmmToMinutes(formatHHMM(selectedSchedule.scheduleDate,selectedSchedule.startMin)) : prev.start,
                        end: outTime ? prev.end : selectedSchedule.endMin ? hhmmToMinutes(formatHHMM(selectedSchedule.scheduleDate,selectedSchedule.endMin)) : prev.end,
                        senmeiCode: selectedSchedule.senmeiCode || prev.senmeiCode,
                        biko: selectedSchedule.biko || "",
                        method: selectedSchedule.methodCodeList || [],
                        kaisu: selectedSchedule.kaisu || 1,
                        outTime
                    }
                    return next;
                });
            } else{
                setForm((p) => ({ ...p, method: [], biko: "", kaisu: maxKaisu + 1 }));
            }
        }
    },[searchDataSenmeiCodeAndDate_Res])
    //-----------------------------------------------
    // useEffect - APIレスポンス(getNextId / table_PortSchedule)
    //-----------------------------------------------
    useEffect(() => {
        if(getNextId_Res){
            buildPayloadAndSetData(getNextId_Res.scheduleId,maxKaisu + 1);
        }
    },[getNextId_Res])

    //===============================================
    // eventHandler
    //===============================================
    //-----------------------------------------------
    // eventHandler - 日付の変更
    //-----------------------------------------------
    const handleChange_entryDate = (value) => {};

    //-----------------------------------------------
    // eventHandler - ドックの変更
    //-----------------------------------------------
    async function handleChangeDock(e) {
        setSelectedDock(Number(e.target.value))
        await searchDataByCalendar_func()
    }
    //-----------------------------------------------
    // eventHandler - セルのクリック（選択中ドックの列のみ）
    //-----------------------------------------------
    function handleColumnClick(dock, e) {
        const rect = e.currentTarget.getBoundingClientRect();
        const y = e.clientY - rect.top;
		setKeepNewId(false);

        // クリックYは「列内」だけの座標でOK
        const min = Math.max(0, Math.min(END_MINUTES - MINUTES_STEP, Math.floor(y / PX_PER_MIN + START_MINUTES)));
		const snapped = Math.round(min / MINUTES_STEP) * MINUTES_STEP;
		setForm((p) => ({ ...p, dock, senmeiCode: senmeiCode, start: snapped, end: (Math.min(snapped + 60 ,END_MINUTES)), outTime: false}))
        openNew();
    }
    //-----------------------------------------------
    // eventHandler - 時間外の新規ダイアログ表示
    //-----------------------------------------------
    function handleOutTimeClick(dock) {
		setKeepNewId(false);
		setForm((p) => ({ ...p, dock, senmeiCode: senmeiCode, start: START_MINUTES, end: (Math.min(START_MINUTES + 60 ,END_MINUTES)), outTime: true}))
        openNew();
    }
	//-----------------------------------------------
    // eventHandler - 削除
    //-----------------------------------------------
	async function handleClickDelete () {
		await deleteData_func(editingId);
        setEditingId("new");
        setOpen(false);
	}
    //-----------------------------------------------
    // eventHandler - 時刻マスのクリック（時刻選択ダイアログ）
    //-----------------------------------------------
    const handleSlotClick = (minutes) => {
        if (clickPrevIndex === minutes || startIndex !== endIndex){
            //開始時刻押下
			resetSelected();
			setStartIndex(minutes);
			setEndIndex(minutes);
			updateSelection(minutes, minutes);
        }else {
            //終了時刻押下
            setEndIndex(minutes);
            updateSelection(startIndex, minutes)
		}
        setClickPrevIndex(minutes);
	}
    //-----------------------------------------------
    // eventHandler - 編集データの変更
    //-----------------------------------------------
	function handleChangeEditingId(value) {
		setKeepNewId(true);
        if (value === "new") {
            setEditingId("new");
			searchDataSenmeiCodeAndDate(form.senmeiCode);
            return
        }
        setEditingId(value);
        searchDataSenmeiCodeAndDate(form.senmeiCode);
    }
    //===============================================
    // Function
    //===============================================
    //-----------------------------------------------
    // Function - 新規入力
    //-----------------------------------------------
    async function openNew() {
        // 漁協ユーザー・仲買人はスケジュール参照のみ可能
		if (authority == 2 || authority == 3) {
			return;
		}
		setKeepNewId(false);
        setEditingId("new");
        await searchShipData();
        await searchDataSenmeiCodeAndDate();
        setOpen(true);
    }

    //-----------------------------------------------
    // Function - 明細表示
    //-----------------------------------------------
	async function openEdit(ev) {
		// 仲買人はスケジュール参照のみ可能
		if (authority == 3) {
			return;
		}
        // 漁業者は自分以外を編集不可。
        // 漁協ユーザーは全入船予定を閲覧可能
        if (!isCoopUser && ev.senmeiCode !== senmeiCode) {
            handleClickSnackBarDisabled();
			return;
        }
		setEditingId(ev.scheduleId);
		await searchDataSenmeiCodeAndDate(ev.senmeiCode);
        setOpen(true);
    }

    //-----------------------------------------------
    // Function - 明細を閉じる
    //-----------------------------------------------
    function closeDialog() {
        setOpen(false);
    }

    //-----------------------------------------------
    // Function - 登録前チェック
    //-----------------------------------------------
    async function saveDialog() {
        if (isCoopUser) {
            return;
        }
        if (!(form.end > form.start)) {
            return;
        }
		if (form.start < START_MINUTES || form.end > END_MINUTES) {
            return;
        }
        if (!(searchData_Res?.Data ?? []).map(item => item.code).includes(senmeiCode)) {
            handleClickRequire();
            return;
        }
            
        if(editingId==="new"){
            await getNextId_func()
            return
        }
        
        buildPayloadAndSetData(editingId,form.kaisu);
        
    } 
    //-----------------------------------------------
    // Function - ドックラベル設定
    //-----------------------------------------------
    const getDockLabel = (dock) => {
        if (dock === 1 || dock === 2) return "1,2番ドック";
        if (dock === 3) return "3番ドック";
        if (dock === 4 || dock === 5) return "4,5番ドック";
        return "ドック未選択";
    };
    
    //-----------------------------------------------
    // Function - 登録処理
    //-----------------------------------------------
    function buildPayloadAndSetData(scheduleId,kaisu){
        const methodList =
            Array.isArray(getDataAll_fishMethod_res?.Data)
                ? getDataAll_fishMethod_res.Data
                    .filter(item => form.method.includes(item.code))
                    .map(item => item.displayName)
                : [];
        const payload = {
            activeFlag: 1,
            id: scheduleId,
            dock: Number(form.dock),
            startMin: form.outTime ? OUT_TIME : unformatHHMM(minutesToHHMM(form.start)),
            endMin: form.outTime ? OUT_TIME : unformatHHMM(minutesToHHMM(form.end)),
            senmeiCode: form.senmeiCode,
            shipName: (searchData_Res?.Data ?? []).find((item) => item.code === form.senmeiCode).displayName,
            biko: (form.biko || "").trim(),
            methodCodeList: form.method,
            methodList: methodList,
            kaisu:kaisu
        };
        const setData = async () => {
            await setData_func(payload);
            await searchDataByCalendar_func();
            await searchShipData();
        }
        setData();
    }

    //-----------------------------------------------
    // Function - 削除処理
    //-----------------------------------------------
    async function deleteEvent() {
        if (isCoopUser || !editingId) return;
		handleOpenConfirm();
    }


    const header_date = {
        marginLeft   : '5px',
        padding      : '7px 10px 5px 10px',
        height       : '47px',
        borderRadius : '10px',
        color        : '#305496',
        fontSize     : '22px',
        fontWeight   : 'bold'
    };

    //-----------------------------------------------
    // Function - 時刻選択を開く
    //-----------------------------------------------
    const openSelectTime = async () => {
		searchDataByCalendar_func();
        setSelectTimeOpen(true);
        setClickPrevIndex(form.start);
		setStartIndex(form.start);
		setEndIndex(form.end - MINUTES_STEP);
		setSlotState((prev) => {
			return (
				prev.map((slot) => {
				const isReserved = (searchPostResponse?.Data ?? []).some((event) => {
                    if(event.startMin === OUT_TIME || event.endMin === OUT_TIME){
                        return false
                    }
					if (event.lineNo !== form.dock || event.scheduleId === editingId){
						return false
					}
					const start = hhmmToMinutes(formatHHMM(event.scheduleDate, event.startMin));
					const end = hhmmToMinutes(formatHHMM(event.scheduleDate, event.endMin));
					return (
						slot.minutes >= start &&
						slot.minutes < end
					)
				})
				return {
					...slot,
					status: isReserved ? "×" : "○",
				}
			})
			)
			
		})
		updateSelection(form.start, form.end - MINUTES_STEP);
	}

    //-----------------------------------------------
    // Function - 時刻選択を閉じる
    //-----------------------------------------------
    const closeSelectTime = () => {
        setSelectTimeOpen(false);
    }

    //-----------------------------------------------
    // Function - 時刻を範囲選択する
    //-----------------------------------------------
    const updateSelection = (startMin, endMin) => {
		const start = Math.floor(startMin / MINUTES_STEP);
		const end = Math.floor(endMin / MINUTES_STEP);
		const step = start <= end ? 1 : -1;
        setSlotState((prev) => {
			const newSlots = prev.map(s => ({ ...s, selected: false}))
            if(step === 1) {
                for (let i = start; i <= end; i++) {
                    if(newSlots[i].status === "×"){
                        setEndIndex(newSlots[i - 1].minutes)
                        break;
                    }
                    newSlots[i].selected = true;
                }
            } else {
                for (let i = start; i >= end; i--) {
                    if(newSlots[i].status === "×"){
                        setEndIndex(newSlots[i + 1].minutes)
                        break;
                    }
                    newSlots[i].selected = true;
			    }
            }
			return newSlots;
		})
	}
    //-----------------------------------------------
    // Function - 時刻の範囲選択をリセット
    //-----------------------------------------------
	const resetSelected = () => {
		setSlotState(prev =>
			prev.map(s => ({
			    ...s,
			    selected: false
			}))
		);
	};
    //-----------------------------------------------
    // Function - 時刻の範囲選択決定
    //-----------------------------------------------
	const saveSelectSlot = () => {
		const start = startIndex <= endIndex ? startIndex : endIndex;
		const end = (startIndex <= endIndex ? endIndex : startIndex) + MINUTES_STEP;
		setForm({...form, start, end});
		setSelectTimeOpen(false);
	}
    //-----------------------------------------------
    // Function - 時間外メニューの開閉
    //-----------------------------------------------
    const handleOutTimeOpen = () => {
        setOutTimeOpen((prev) => !prev);
    };
    const handleClickAway = () => {
        setOutTimeOpen(false);
    };

	//===============================================
	// UI Message
	//===============================================
    // コンファームの表示
    const handleOpenConfirm = () => { setOpenConfirm(true) };
    
    // コンファームを閉じる
    const handleCloseConfirm = () => { setOpenConfirm(false) };

	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true) };
    
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false);
    };

	// スナックバー(異常)を表示
    const handleClickSnackBarMessageFalse = () => { setOpenSnackBarMessageFalse(true) };
    
	// スナックバー(異常)を閉じる
    const handleCloseSnackBarMessageFalse = (event, reason) => {
        if (reason === 'clickaway') { 
			return; 
		}
		setOpenSnackBarMessageFalse(false);
    }
	// スナックバー(編集不可)を表示
    const handleClickSnackBarDisabled= () => { setOpenSnackBarDisabled(true) };
    
	// スナックバー(編集不可)を閉じる
    const handleCloseSnackBarDisabled = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarDisabled(false);
    };
    // スナックバーを表示
    const handleClickRequire = () => { setOpenRequire(true) };
    
	// スナックバーを閉じる
    const handleCloseRequire = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenRequire(false);
    };

    //===============================================
    // JSXのレンダー
    //===============================================
    return (
        <>
            <HeaderMobile />
            <div className='scheduleMobile bodyContens' style={{ marginTop: '60px' }}>
                <Grid container justifyContent="space-between" alignItems="center" style={{paddingTop:"2px"}}>
                    <div style={header_date}>入船スケジュール登録</div>
                    <ClickAwayListener onClickAway={handleClickAway}>
                        <Box sx={{ position: 'relative' }}>
                            <Button
                                variant="contained"
                                onClick={handleOutTimeOpen}
                                size="large"
                                sx={{
                                    px: 2,
                                }}
                            >
                                時間外
                            </Button>
                            {outTimeOpen ? (
                                <>
                                    {
                                    !isCoopUser ?
                                        <Button
                                            size    = "large"
                                            variant = "contained"
                                            startIcon={<AddCircleIcon />}
                                            onClick = {(e) => {
                                                e.stopPropagation();
                                                handleOutTimeClick(selectedDock)
                                            }}
                                            sx={{
                                                position: 'absolute',
                                                top: 50,
                                                right: 0,
                                                width: '120px',
                                                zIndex: 20,
                                                color: "#fff",
                                            }}
                                        >
                                            新　規
                                        </Button>
                                        : null
                                    }
                                    {(searchPostResponse?.Data ?? [])
                                    .filter((ev) => (isCoopUser || ev.senmeiCode === senmeiCode) && (ev.startMin === OUT_TIME || ev.endMin === OUT_TIME))
                                    .map((ev, index) => {
                                        return (
                                            <Chip
                                                key={ev.id}
                                                clickable
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openEdit(ev);
                                                }}                                         
                                                sx={{
                                                    position: 'absolute',
                                                    top: (isCoopUser ? 50 : 100) + 40 * index,
                                                    right: 0,
                                                    maxWidth: 'none',
                                                    zIndex: 20,
                                                    border: "1px solid",
                                                    borderColor: "divider",
                                                    bgcolor: "#4682b4",
                                                    color: "#fff",
                                                    boxShadow: "0 1px 4px rgba(0, 0, 0, 0.66)",
                                                    p: 2,
                                                    "&:hover": {
                                                        backgroundColor: "#4682b4",
                                                    },
                                                    "&:active": {
                                                        backgroundColor: "#4682b4",
                                                    },
                                                    "&.Mui-focusVisible": {
                                                        backgroundColor: "#4682b4",
                                                    },
                                                }}
                                                label={`${ev.lineNo ? `${ev.lineNo}番ドック ` : ""}${isCoopUser && ev.senmei ? `${ev.senmei} ` : ""}${ev.kaisu}回目`}
                                            />
                                        )
                                    })}
                                </>
                            ) : null}
                        </Box>
                    </ClickAwayListener>
                </Grid>
                <Box sx={{ p: 2 }}>
                    {/* ドック選択（スマホ用：選択したドック列だけ表示） */}
                    <Box sx={{ pb: 1 }}>
                        <CustomSelect
                            id         = "bidList_search_lineNo"
                            label      = "ドックNo"
                            width      = "100%"
                            dataList   = {dogList} 
                            selectedId = {selectedDock}
                            onChange={(e) => handleChangeDock(e)}
                        />
                    </Box>

                    <Card variant="outlined" sx={{ overflow: "hidden" }}>
                        <Box
                            ref={scrollRef}
                            sx={{
                                height: "calc(100vh - 250px)",
                                overflowY: "auto",
                                bgcolor: "background.default",
                                // 対応ブラウザではスクロールバー領域を常に確保してズレを抑える
                                scrollbarGutter: "stable",
                            }}
                        >
                            {/* ヘッダ（sticky） */}
                            <Box
                                sx={{
                                    height: HEADER_H,
                                    display: "flex",
                                    alignItems: "center",
                                    borderBottom: "1px solid",
                                    borderColor: "#fff",
                                    bgcolor: "#222B35",
                                    color: "#fff",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 10,
                                }}
                            >
                                <Box sx={{ width: TIME_COL_W, px: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                        時刻
                                    </Typography>
                                </Box>

                                {/* スマホは選択中ドックのみ表示 */}
                                <Box sx={{ flex: 1, px: 1 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 700, textAlign: "center" }}>
                                        {getDockLabel(selectedDock)}
                                    </Typography>
                                </Box>
                            </Box>

                            {/* ボディ本体 */}
                            <Box sx={{ display: "flex" }}>
                                {/* 時刻列 */}
                                <Box sx={{ width: TIME_COL_W, position: "relative", height: bodyH }}>
                                {timeSlot.map((m) => {
                                    const showLabel = m.minutes % 60 === 0;
                                    if(m.minutes >= OPERATING_MINUTES){
                                        return
                                    }
                                    return (
                                        <Box
                                            key={m.minutes}
                                            sx={{
                                                position: "absolute",
                                                top: m.minutes * PX_PER_MIN,
                                                left: 0,
                                                right: 0,
                                                height: MINUTES_STEP * PX_PER_MIN,
                                                borderTop: "1px solid",
                                                borderColor: "divider",
                                                px: 1,
                                                display: "flex",
                                                alignItems: "flex-start",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            {showLabel && m.minutes !== OPERATING_MINUTES && (
                                                <Typography variant="caption" sx={{ opacity: 0.75 }}>
                                                    {minutesToHHMM(m.minutes + (START_MINUTES))}
                                                </Typography>
                                            )}
                                        </Box>
                                    );
                                })}
                            </Box>

                            {/* ドック列（選択中の1列のみ） */}
                            <Box sx={{ flex: 1, position: "relative", height: bodyH }}>
                                {/* 現在時刻ライン */}
								{nowY >= START_MINUTES * PX_PER_MIN && nowY <= END_MINUTES * PX_PER_MIN && (
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            left: 0,
                                            right: 0,
                                            top: nowY - START_MINUTES * PX_PER_MIN,
                                            height: 0,
                                            borderTop: "2px solid",
                                            borderColor: "error.main",
                                            opacity: 0.65,
                                            zIndex: 3,
                                            pointerEvents: "none",
                                        }}
                                    />
								)}

                                {/* 背景グリッド（1列分） */}
                                <Box
                                    sx={{
                                        position: "absolute",
                                        inset: 0,
                                        zIndex: 1,
                                    }}
                                >
                                    <Box
                                        onClick={(e) => { if (!isCoopUser) handleColumnClick(selectedDock, e); }}
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            cursor: isCoopUser ? "default" : "pointer",
                                            borderLeft: "1px solid",
                                            borderColor: "divider",
                                            backgroundImage: `repeating-linear-gradient(
                                                to bottom,
                                                transparent 0px,
                                                transparent ${(MINUTES_STEP * PX_PER_MIN) - 1}px,
                                                rgba(0,0,0,0.08) ${(MINUTES_STEP * PX_PER_MIN) - 1}px,
                                                rgba(0,0,0,0.08) ${(MINUTES_STEP * PX_PER_MIN)}px
                                            )`,
                                        }}
                                        />
                                    </Box>

                                    {/* 予定ブロック（選択中ドックのみ） */}
                                    {(searchPostResponse?.Data ?? [])
                                    .filter((ev) => {
                                        if(ev.startMin === OUT_TIME || ev.endMin === OUT_TIME){
                                            return false
                                        }
                                        if (selectedDock === 1 || selectedDock === 2){
                                            return ev.lineNo === 1 || ev.lineNo === 2
                                        } else if (selectedDock === 3){
                                            return ev.lineNo === 3
                                        } else if (selectedDock === 4 || selectedDock === 5){
                                            return ev.lineNo === 4 || ev.lineNo === 5
                                        }
                                        return false
                                    })
                                    .map((ev) => {
                                        const senmei = ((searchData_Res?.Data ?? []).find((item) => item.code === ev.senmeiCode)?.displayName) ?? "";
                                        const top = (hhmmToMinutes(formatHHMM(ev.scheduleDate, ev.startMin)) - START_MINUTES) * PX_PER_MIN;
                                        const height = Math.max(18, (hhmmToMinutes(formatHHMM(ev.scheduleDate, ev.endMin)) - hhmmToMinutes(formatHHMM(ev.scheduleDate, ev.startMin))) * PX_PER_MIN);

                                        return (
                                            <Box
                                                key={ev.id}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    openEdit(ev);
                                                }}
                                                sx={{
                                                    position: "absolute",
                                                    left: "6px",
                                                    right: "6px",
                                                    top,
                                                    height,
                                                    borderRadius: 1.5,
                                                    border: "1px solid",
                                                    borderColor: "divider",
                                                    bgcolor: "#4682b4",
                                                    color: "#fff",
                                                    boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                                                    p: 1,
                                                    overflow: "hidden",
                                                    cursor: "pointer",
                                                    zIndex: 2,
                                                }}
                                            >
                                                <Typography variant="caption" sx={{ fontWeight: 800, display: "block" }}>
                                                    {senmei}
                                                </Typography>
                                                <Typography variant="caption" sx={{ opacity: 0.85 }}>
                                                    {formatHHMM(ev.scheduleDate, ev.startMin)}–{formatHHMM(ev.scheduleDate, ev.endMin)}
                                                </Typography>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Box>
                    </Card>

                    {/* 追加/編集ダイアログ */}
                    <Dialog open={open} onClose={closeDialog} maxWidth="sm" sx={{
                        '& .MuiPaper-root': {
                            marginLeft: 1,
                            marginRight: 1,
                        },
                    }}>
                        <DialogTitle>
                            <TitleBar title="スケジュール登録" color="#305496" />
                        </DialogTitle>
                        <DialogContent style={{ border: 'none' }}>
                            <Stack spacing={2} sx={{ mt: 1 }}>
                                <TextField
                                    select
                                    label="ドック"
                                    value={form.dock ?? ""}
                                    disabled={isCoopUser}
                                    sx={{
                                        width: '240px', '& .MuiInputBase-root': {
                                            height: 40,
                                        },
                                    }}
                                    onChange={(e) => setForm((p) => ({ ...p, dock: Number(e.target.value) }))}
                                >
                                    {DOCKS.map((d) => (
                                        <MenuItem key={d} value={d}>{`${d}番ドック`}</MenuItem>
                                    ))}
                                </TextField>
                                <Grid container gap={1}>
                                    <Button variant="outlined" sx={{ width:'130px' }} onClick={()=>openSelectTime()} disabled={form.outTime || isCoopUser}>
                                        時刻を選択する
                                    </Button>
                                    <Typography sx={{ alignContent: 'center', visibility: `${form.outTime ? 'hidden': 'visible'}`}}>
                                        {minutesToHHMM(form.start)} - {minutesToHHMM(form.end)}
                                    </Typography>
                                </Grid>
                                <Grid container gap={1}>
                                    <Switch checked={form.outTime} disabled={isCoopUser} onChange={(e)=>setForm(p => ({...p, outTime: e.target.checked}))}/>
                                    <Typography sx={{ alignContent: 'center' }}>
                                        時間外
                                    </Typography>
                                </Grid>
                                <TextField
                                    select
                                    label="荷主"
                                    sx={{ 
                                        width:'240px','& .MuiInputBase-root': {
                                            height: 40,
                                        }, 
                                    }}
                                    value={form.senmeiCode ?? ''}
                                    disabled
                                >
                                    {(searchData_Res?.Data ?? []).map((item) => (
                                        <MenuItem key={item.code} value={item.code}>{item.displayName}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField
                                    select
                                    label="回数"
                                    value={editingId}
                                    disabled={isCoopUser}
                                    sx={{ 
                                        width: '240px', '& .MuiInputBase-root': {
                                            height: 42,
                                        }, 
                                    }}
									onChange={(e) => handleChangeEditingId(e.target.value )}
                                >
                                    {(sortedSchedule ?? []).map((item) => 
                                    (
                                        <MenuItem key={item.scheduleId} value={item.scheduleId}>{`${item.kaisu}回目`}</MenuItem>
                                    ))}
                                    {
                                        !isCoopUser ?
                                            <MenuItem key={"new"} value={"new"}>{(maxKaisu) + 1 + "回目"}</MenuItem>
                                            : null
                                    }
                                </TextField>
                                <TextField
                                    label="漁法"
                                    sx={{ 
                                        width: '240px', '& .MuiInputBase-root': {
                                        },
                                    }}
                                    value={(getDataAll_fishMethod_res?.Data ?? [])
                                        .filter(item => form.method.includes(item.code))
                                        .map(item => item.displayName)
                                        .join('、')}
                                    disabled
                                    multiline
                                />

                                <TextField
                                    label="備考"
                                    sx={{ width: '240px' }}
                                    value={form.biko}
                                    disabled={isCoopUser}
                                    onChange={(e) => setForm((p) => ({ ...p, biko: e.target.value }))}
                                    multiline
                                    minRows={3}
                                />
                            </Stack>
                        </DialogContent>

                        <DialogActions>
                            {!isCoopUser && editingId !== "new" && (
                                <Button color="error" onClick={deleteEvent}>
                                    削除
                                </Button>
                            )}
                            <Box sx={{ flex: 1 }} />
                            <Button onClick={closeDialog}>{isCoopUser ? "閉じる" : "キャンセル"}</Button>
                            {
                                !isCoopUser ?
                                <Button
                                    variant="contained"
                                    onClick={saveDialog}
                                    style={{ margin: '1rem', color: '#fff', backgroundColor: '#305496' }}
                                >
                                保存
                                </Button>
                                : null
                            }
                        </DialogActions>
                    </Dialog>
                    <Dialog disableRestoreFocus open={selectTimeOpen} onClose={() => closeSelectTime()} maxWidth="sm" sx={{
                        '& .MuiPaper-root': {
                            marginLeft: 1,
                            marginRight: 1,
                        },
                    }}>
                        <DialogTitle sx={{ paddingLeft: 1,paddingRight: 1 }}>
                            <TitleBar title="時刻選択" color="#305496" />
                        </DialogTitle>
                        <DialogContent sx={{ paddingLeft: 1,paddingRight: 1 }}>
                            {(groupedByHour ?? []).map((hourRow, hour) => (
                                <Grid key={hourRow[0].minutes} container gap={1} sx={{padding: 0.1, alignItems: 'center', justifyContent: 'center', paddingBottom: 2}}>
                                    <Grid key={hour} container sx={{ width: 40, justifyContent: 'right' }} >
                                        <Typography key={hour}>{hour + START_HOURS}時</Typography>
                                    </Grid>
                                        {hourRow.map((minRow) => (
                                        <ButtonBase 
                                            key={minRow.minutes}
                                            onClick={() => handleSlotClick(minRow.minutes)}
                                            sx={{ 
                                                width: '18%',
                                                height: 64,
                                                border: '1px solid #ccc',
                                                borderRadius: 1,
                                                bgcolor: minRow.selected ? '#305496' : 'transparent',
                                                color: minRow.selected ? '#fff' : 'text.primary',
                                                '&.Mui-disabled': {
                                                opacity: 0.4,
                                                cursor: 'not-allowed',
                                                },
                                            }}
                                            disabled={minRow.status === "×"}
                                        >
                                            <Box sx={{
                                                height: '100%',
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>
                                                <Typography key={minRow.minutes}>
                                                        {minutesToHHMM(minRow.minutes)}
                                                </Typography>
                                                <Typography  variant="h6">
                                                    {minRow.status}
                                                </Typography>
                                            </Box>
                                        </ButtonBase>
                                        ))}
                                </Grid>
                            ))}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={closeSelectTime}>キャンセル</Button>
                            <Button
                                onClick={saveSelectSlot}
                                style = {{ margin: '1rem', color:'#fff', backgroundColor: '#305496' }}
                            >
                                決定
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Box>
                <div style={{ position: 'fixed', left: 0, bottom: 0, width: '100%', color: 'white', textAlign: 'center', }}>
                    <Button
                            color     = "secondary"
                            size      = "large"
                            style     = {{ fontSize: '20px', width: '90%',marginBottom: '1rem', color:'#fff', backgroundColor:'grey' }}
                            variant   = "contained"
                            startIcon = {<InfoIcon />}
                            onClick   = {() => { navigate(`/portHomeMobile`) }}
                    >ホームへ戻る
                    </Button>
                </div>
            </div>
            <CustomSnackBar
                open            = {openSnackBarTrue}
                onClose         = {() => handleCloseSnackBarTrue()}
                severity        = "success"
                backgroundColor = "#2e8b57"
                message         = "登録しました"
            />
            <CustomSnackBar
                open            = {openSnackBarMessageFalse}
                onClose         = {() => handleCloseSnackBarMessageFalse()}
                severity        = "error"
                backgroundColor = "#db7093"
                message         = {message}
            />
            <CustomConfirm
                open      = {openConfirm}
                onClose   = {() => handleCloseConfirm()}
                onClickNG = {() => handleCloseConfirm()}
                onClickOK = {async () => await handleClickDelete()}
                message   = "指定データの削除を行います。よろしいですか？"
            />
            <CustomSnackBar
                open            = {openSnackBarDisabled}
                onClose         = {() => handleCloseSnackBarDisabled()}
                severity        = "error"
                backgroundColor = "#db7093"
                message         = "他の荷主のデータは編集することができません"
            />
            <CustomSnackBar
                open            = {openRequire}
                onClose         = {() => handleCloseRequire()}
                severity        = "error"
                backgroundColor = "#db7093"
                message         = "「荷主」が入力されていません"
            />
        </>
    );
}

export default ScheduleMobile;
